import Autocomplete from '@mui/material/Autocomplete';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

export const ReminderToSignCategory = () => {
  const { t } = useTranslation();

  return (
    <Stack spacing={2}>
      <Stack direction="row" justifyContent="space-between" alignItems="center" gap={1}>
        <Typography>{t('share_document_v3.automatic_reminders.send')}</Typography>
        <Autocomplete
          size="small"
          sx={{ width: '100%' }}
          options={[]}
          renderInput={(params) => (
            <TextField
              {...params}
              label={t('share_document_v3.automatic_reminders.automatic_reminder_to_sign.sign_reminder_default_template')}
            />
          )}
        />
      </Stack>
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Typography>{t('share_document_v3.automatic_reminders.automatic_reminder_to_sign.if_signee_hanvent_signed_after')}</Typography>
        <TextField value={1} size="small" type="number" sx={{ width: 40 }} />
        <Typography>{t('share_document_v3.automatic_reminders.days')}</Typography>
      </Stack>
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Typography>{t('share_document_v3.automatic_reminders.automatic_reminder_to_sign.send_every')}</Typography>
        <TextField value={1} size="small" type="number" sx={{ width: 40 }} />
        <Typography>{t('share_document_v3.automatic_reminders.automatic_reminder_to_sign.days_until_signed')}</Typography>
      </Stack>
    </Stack>
  );
};
